import { BaseViewStore, ContainerProductHyperlinkCellData } from 'core/stores';
import { action, observable, makeObservable } from 'mobx';
import { ConfirmModalParams } from 'core/models';
import ReceivingStore from './ReceivingStore';
import { formatDate, notificationError } from 'core/utils';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';

class ReceivingDetailViewStore extends BaseViewStore {
	@observable receiving = {};
	tableData = {};
	noDataItem = true;

	constructor(rootStore) {
		super(rootStore);
		makeObservable(this);
		this.receivingStore = new ReceivingStore(rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		await this.getReceiving();
		this.tableData = {
			columns: [
				{
					key: 'quantity',
					title: 'RECEIVINGDETAILVIEW.TABLE.QUANTITY',
					selected: true,
					width: 200,
					filter: null,
				},
				{
					key: 'product.mainSku',
					dataCell: ContainerProductHyperlinkCellData,
					routeName: 'master.app.main.product.list.detail',
					title: 'RECEIVINGDETAILVIEW.TABLE.PRODUCTSKU',
					selected: true,
					width: 200,
					filter: null,
					linkParamField: 'productId'
				},
			],
			actions: {},
			sortObject: [],
		};
		this.resume();
	};

	@action.bound
	getReceiving = async () => {
		await this.receivingStore.getReceiving(this.rootStore.routerStore.routerState.params.id, {
			embed: [
				'receivingProducts',
				'receivingProducts.product',
				'receivingStatus',
				'receivingType',
				'warehouseTo',
				'warehouseFrom',
			],
		});
		this.receiving = this.receivingStore.item;
		this.receiving.estimatedReceivingDate = formatDate(this.receiving.estimatedReceivingDate, false, 'L');
		this.receiving.actualReceivingDate = formatDate(this.receiving.actualReceivingDate, true, 'L');
	};

	@action.bound
	approveReceivingAsync = async () => {
		this.suspend();
		const item = this.rootStore.viewStore.selectedConfirmModal.data;
		try {
			await this.receivingStore.approve(item.id, sourceOfChange.approveReceivingDetail);
			this.rootStore.notificationStore.success(['RECEIVINGVIEW.APPROVESUCCESS', { ref: item.ref }]);
			await this.getReceiving();
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
		this.resume();
	};
}

export default ReceivingDetailViewStore;
